import AbstractRestApi from '@/api/RestApi/AbstractRestApi'
import ResponseHandler from '@/api/response/ResponseHandler'
import apiClient from '@/api/ApiClient'

class PromoBannersApiClient extends AbstractRestApi {
    getBaseUrl() {
        return '/api/v1/banners'
    }

    moveToPosition(id, position) {
        return ResponseHandler.handle(
            apiClient.put(this.getItemIri(id, 'move-to-position'), {
                position,
            })
        ).then(this.refreshSelectapiStore.bind(this))
    }
}

export default new PromoBannersApiClient()
